export default [
  //业务查询 地址示例
  // http://localhost:8080/h5.html?token=TOKEN_715c30a658234a86b80dded6ac63842f#/business/index
  // http://wx.hztywl.cn/bzb/h5.html?token=TOKEN_715c30a658234a86b80dded6ac63842f#/business/index

  /**
   * 业务查询首页
   * query
   **** token 医生token
   */
  {
    path: '/business/index',
    meta: {
      title: '业务查询'
    },
    component: () => import('../pages/business/index')
  },

  {
    path: '/business/outpatient',
    meta: {
      title: '门诊概况'
    },
    component: () => import('../pages/business/outpatient')
  },
  {
    path: '/business/inhos',
    meta: {
      title: '住院概况'
    },
    component: () => import('../pages/business/inhos')
  },

  {
    path: '/business/order',
    meta: {
      title: '挂号概况'
    },
    component: () => import('../pages/business/order')
  },

  {
    path: '/business/online',
    meta: {
      title: '网络门诊概况'
    },
    component: () => import('../pages/business/online')
  },

  {
    path: '/business/consult',
    meta: {
      title: '咨询概况'
    },
    component: () => import('../pages/business/consult')
  },

  {
    path: '/business/recipe',
    meta: {
      title: '处方概况'
    },
    component: () => import('../pages/business/recipe')
  },


]



// WEBPACK FOOTER //
// ./h5/router/business.js